<template>
    <div>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader mx-width bg-primary text-light">
            <div class="pageTitle left">
                Daftar
            </div>
            <div class="right">
                <router-link :to="{name:'care-center'}" class="headerButton">
                    <div>
                        <p style="font-size: 10px;line-height: 1.5;margin: 0;width: 80px;text-align: right;">Hubungi<br>Qiosfin Care</p>
                    </div>
                    <ion-icon class="icon ml-1" name="chatbox-ellipses"></ion-icon>
                </router-link>
            </div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" class="pb-0">
            <div class="section form-card-section pt-3">
                <div class="text-center mb-3" style="position:relative;">
                    <img :src="require('@/assets/image/logo_header_white.png')" alt="logo" height="50px;">
                </div>
                <div class="form-card mb-4">
                    <div class="form-group basic">
                        <label class="label">Nama</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama Anda / Toko" v-model="auth_data.name" style="text-transform:capitalize;">
                    </div>
                    <div class="form-group basic">
                        <label class="label">Nomor Handphone (WhatsApp)</label>
                        <input type="number" class="form-control" placeholder="0823xxxxxxx" v-model="auth_data.phone">
                    </div>
                    <div class="form-group basic">
                        <label class="label">Kode Referral</label>
                        <input type="text" class="form-control" placeholder="(Optional)" v-model="auth_data.referred_by">
                    </div>
                    <div class="form-group mb-1 mt-1 text-center" style="line-height:normal;">
                        <small>Dengan melakukan pendaftaran berarti anda telah menyetujui <router-link :to="{name:'tos'}"><b>Syarat & Ketentuan</b></router-link> dan <router-link :to="{name:'privacy'}"><b>Kebijakan Privasi</b></router-link> {{ VUE_ENV.VUE_APP_NAME }}</small>
                    </div>
                    <div class="form-group basic">
                        <ButtonLoader :loading="loading.button" :styled="'btn btn-primary btn-block btn-lg'" @click.native="submit()">Daftar</ButtonLoader>
                        <router-link :to="{name:'auth.login'}" class="btn btn-outline-primary btn-block">~ Sudah punya akun? Masuk Sekarang ~</router-link>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
export default {
    name: 'auth.register',
    data() {
        return {
            
        }
    },
    created(){
        this.RESET_AUTH_DATA()
        if (this.isAuth) {
            this.$router.push({ name: 'home' })
        }
    },
    computed:{
        ...mapGetters(['isAuth']),
        ...mapState(['loading','toast','VUE_ENV']),
        ...mapState('auth',{
            auth_data: state => state.auth_data,
        }),
    },
    methods:{
        ...mapActions('auth', ['register']),
        ...mapMutations('auth', ['RESET_AUTH_DATA']),
        submit(){
            this.$store.commit('SET_LOADING', {button:true})
            this.register().then(() => {
                window.fbq('track', 'CompleteRegistration')
                this.$store.commit('SET_LOADING', {button:false})
                this.$router.push({ name: 'auth.login.verify' })
            }).catch((error) => {
                this.$store.commit('SET_LOADING', {button:false})
                this.$store.commit('SET_TOAST', {show:true,message:error.data.message,tipe:'default',icon:'danger'})
            })
        },
    },
    mounted() {
        document.body.classList.add('bg-white')
    },
    destroyed() {
        this.$store.commit('RESET_LOADING')
    },
}
</script>